import { useTranslation } from 'react-i18next'

import Text from '@/components/atomic/atoms/Text'
import Section from '@/components/atomic/molecules/Section'

export const HospitalIntroduction = ({ introduction }: { introduction: string }) => {
  const { t } = useTranslation()

  return (
    <Section title={t('templates.hospitalDetail.introTitle')}>
      <Text element="p" type="description2">
        {introduction}
      </Text>
    </Section>
  )
}
